import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 152200 165320"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#2b2a29;stroke-width:1832.03}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g>
      <g id="_1974342850096">
        <circle
          cx={131190}
          cy={143931}
          r={20094}
          className="fill stroke1"
          style={{
            strokeWidth: 1832.03,
          }}
        />
        <ellipse
          cx={76317}
          cy={28187}
          className="fill stroke1"
          style={{
            strokeWidth: 1832.03,
          }}
          rx={27271}
          ry={27270}
        />
        <circle
          cx={21011}
          cy={144311}
          r={20094}
          className="fill stroke1"
          style={{
            strokeWidth: 1832.03,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
